import type {Logger} from '@feature-hub/core';
import type {PriceTypeV1} from '../index.js';

const storageKey = `price-type-v1`;

const storage =
  typeof window === `undefined` ? undefined : window.sessionStorage;

export function writePriceTypeToStorage(
  priceType: PriceTypeV1 | undefined,
  logger: Logger = console,
): void {
  if (!storage) {
    return;
  }

  try {
    if (priceType) {
      storage.setItem(storageKey, JSON.stringify(priceType));
    } else {
      storage.removeItem(storageKey);
    }
  } catch (error) {
    logger.error(error);
  }
}

export function readPriceTypeFromStorage(
  logger: Logger = console,
): PriceTypeV1 | undefined {
  if (!storage) {
    return undefined;
  }

  try {
    const stringifiedPriceType = storage.getItem(storageKey);

    return stringifiedPriceType ? JSON.parse(stringifiedPriceType) : undefined;
  } catch (error) {
    logger.error(error);

    return undefined;
  }
}
